import React from 'react';
import { useAuth } from './contexts/AuthContext';
import LoginPage from './components/LoginPage';
import AppContent from './AppContent';

export function AuthenticatedApp() {
  const { isAuthenticated, isInitialized } = useAuth();

  // Mostra loading durante l'inizializzazione
  if (!isInitialized) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-black flex items-center justify-center">
        <div className="text-center text-white">
          <div className="text-6xl mb-4">🎬</div>
          <div className="text-xl font-semibold mb-4">KainoTV</div>
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-2"></div>
            Inizializzazione...
          </div>
        </div>
      </div>
    );
  }

  // Se non autenticato, mostra LoginPage
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Se autenticato, mostra l'app principale
  return <AppContent />;
}

export default AuthenticatedApp;
